// autogenerated from config/config.js

export const SSO_URI = "https://sso.8x8.com";
export const SSO_CLIENT_ID = "chalet";
export const MAX_SILENCE_MILLISECONDS = 10000;
export const PULSE_MILLISECONDS = 1000;
export const APP_VERSION = "0.325.0-undefined";
